import {
    REQUEST_PROTECTION_PLAN_IDF,
    RECEIVE_PROTECTION_PLAN_IDF,
    IProtectionPlanIDFState,
    ProtectionPlanTypes,
    IBillingInfoState,
    BillingInfoTypes,
    REQUEST_BILLING_INFO,
    RECEIVE_BILLING_INFO,
} from "./types";

const initialState: IProtectionPlanIDFState = { protectionPlanData: {}, isLoading: false };

export function protectionPlanIDFReducer(state = initialState, action: ProtectionPlanTypes): IProtectionPlanIDFState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_PROTECTION_PLAN_IDF:
            return {
                isLoading: true,
                protectionPlanData: state.protectionPlanData,
            };
        case RECEIVE_PROTECTION_PLAN_IDF:
            return {
                isLoading: false,
                protectionPlanData: action.protectionPlanData,
            };
        default:
            return state;
    }
}

const initialStateBillingInfo: IBillingInfoState = {
    isLoading: false,
    billingInfoData: undefined,
};

export function billingInfoReducer(state = initialStateBillingInfo, action: BillingInfoTypes): IBillingInfoState {
    if (state === undefined) {
        return initialStateBillingInfo;
    }

    switch (action.type) {
        case REQUEST_BILLING_INFO:
            return {
                isLoading: true,
                billingInfoData: state.billingInfoData,
            };
        case RECEIVE_BILLING_INFO:
            return {
                isLoading: false,
                billingInfoData: action.data,
            };
        default:
            return state;
    }
}
